import { VenueCategoryUnionType, VenueDetailsType } from '@api';
import {
  useVenueFormSchema,
  VenueFormFields,
  VenueFormValuesType,
} from '@common';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { useUpdateVenue } from './hooks';

type EditVenueFormPropsType = {
  venue: VenueDetailsType;
  venueCategories: VenueCategoryUnionType[];
  onClose: () => void;
};

export const EditVenueForm: React.FC<EditVenueFormPropsType> = ({
  venue,
  venueCategories,
  onClose,
}) => {
  const { schema, defaultValues } = useVenueFormSchema(venue);
  const { updateVenue } = useUpdateVenue(venue.id);

  const methods = useForm<VenueFormValuesType>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const handleSubmit = async (data: VenueFormValuesType) => {
    await updateVenue(data);
    onClose();
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <VenueFormFields venueCategories={venueCategories} onClose={onClose} />
      </form>
    </FormProvider>
  );
};
